import { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const AllSelectedIcon = ({
  width = '17',
  height = '17',
  color = '#73767D'
}: Omit<IconSvgProps, 'children'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 17 17"
  >
    <g clipPath="url(#clip0_3224_53089)">
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.75"
        d="M15.097 4.438v9.267c0 .903-.733 1.636-1.636 1.636H4.125"
      ></path>
      <mask id="path-2-inside-1_3224_53089" fill="#fff">
        <path
          fillRule="evenodd"
          d="M2.337 1.756a.824.824 0 00-.824.823v10.234c0 .455.37.823.824.823h10.235a.824.824 0 00.823-.823V2.579a.824.824 0 00-.823-.823H2.337zm8.101 4.335a.375.375 0 10-.53-.53L6.435 9.033 5 7.6a.375.375 0 00-.53.53l1.7 1.7a.375.375 0 00.53 0l3.738-3.74z"
          clipRule="evenodd"
        ></path>
      </mask>
      <path
        fill={color}
        fillRule="evenodd"
        d="M2.337 1.756a.824.824 0 00-.824.823v10.234c0 .455.37.823.824.823h10.235a.824.824 0 00.823-.823V2.579a.824.824 0 00-.823-.823H2.337zm8.101 4.335a.375.375 0 10-.53-.53L6.435 9.033 5 7.6a.375.375 0 00-.53.53l1.7 1.7a.375.375 0 00.53 0l3.738-3.74z"
        clipRule="evenodd"
      ></path>
      <path
        fill={color}
        d="M10.439 5.56l-.53.53.53-.53zm0 .53l.53.531-.53-.53zm-.53-.53l.53.53-.53-.53zM6.434 9.034l-.53.53a.75.75 0 001.06 0l-.53-.53zM5 7.6l-.53.53L5 7.6zm-.53 0l-.53-.53.53.53zm0 .53l-.53.53.53-.53zm1.7 1.7l-.53.53.53-.53zm.53 0l.53.53-.53-.53zM2.263 2.58c0-.041.033-.074.074-.074v-1.5c-.87 0-1.574.704-1.574 1.573h1.5zm0 10.233V2.579h-1.5v10.234h1.5zm.074.073a.074.074 0 01-.074-.073h-1.5c0 .869.705 1.573 1.574 1.573v-1.5zm10.235 0H2.337v1.5h10.235v-1.5zm.073-.073c0 .04-.033.073-.073.073v1.5c.869 0 1.573-.704 1.573-1.573h-1.5zm0-10.234v10.234h1.5V2.579h-1.5zm-.073-.073c.04 0 .073.033.073.073h1.5c0-.869-.704-1.573-1.573-1.573v1.5zm-10.235 0h10.235v-1.5H2.337v1.5zM9.908 6.09a.375.375 0 010-.53l1.06 1.06c.44-.44.44-1.152 0-1.59l-1.06 1.06zm.53 0a.375.375 0 01-.53 0l1.06-1.06a1.125 1.125 0 00-1.59-.001l1.06 1.06zM6.965 9.564l3.473-3.473-1.06-1.061-3.474 3.473 1.06 1.061zM4.47 8.13l1.434 1.434 1.06-1.06-1.433-1.435L4.47 8.13zm.53 0a.375.375 0 01-.53 0l1.06-1.06a1.125 1.125 0 00-1.59 0L5 8.13zm0-.53a.375.375 0 010 .53L3.94 7.07c-.44.439-.44 1.15 0 1.59L5 7.6zm1.7 1.699L5 7.599 3.94 8.66l1.7 1.7L6.7 9.299zm-.53 0a.375.375 0 01.53 0l-1.06 1.06c.438.44 1.15.44 1.59 0L6.17 9.3zM9.907 5.56L6.17 9.3l1.061 1.06 3.739-3.738-1.06-1.06z"
        mask="url(#path-2-inside-1_3224_53089)"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_3224_53089">
        <path
          fill="#fff"
          d="M0 0H14V14H0z"
          transform="translate(1.513 1.756)"
        ></path>
      </clipPath>
    </defs>
  </svg>
)

export default AllSelectedIcon
